/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Control_TrackInputs */



/**
* | output |
* | --- |
* | "Creating AD control track..." |
*
* @param {Audio_Description_Export_Status_Control_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_control_track = /** @type {((inputs?: Audio_Description_Export_Status_Control_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Control_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création de la piste de contrôle AD...")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Steuerspur wird erstellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione della traccia di controllo AD...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание управляющей дорожки АД...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando pista de control de AD...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在创建 AD 控制音轨...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD コントロールトラックを作成中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD कंट्रोल ट्रैक बनाया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A criar a faixa de controlo de AD...")
	return /** @type {LocalizedString} */ ("Creating AD control track...")
});